<div class="product-list-item">
  <div class="col-12 col-md-2 product-list-item-img">
    <a [attr.aria-label]="
      !product.images?.hasOwnProperty('PRIMARY')
        ? ('productDetails.noProductImage'
          | cxTranslate: { product: product.name })
        : undefined
    " [routerLink]="{cxRoute:'product',params:product}|cxUrl" class="cx-product-image-container">
      <cx-media class="cx-product-image" [container]="product.images?.PRIMARY || product.images" format="product"
        [alt]="product.name || product.summary"></cx-media>
    </a>
  </div>
  <div class="d-flex col-12 col-md-10 kb-product-item-login-block">
    <div class="d-flex flex-column col-md-3">
      <a [routerLink]="{cxRoute:'product',params:product}|cxUrl" class="cx-product-name">
        <label class="product-code" [innerHtml]="product.code |searchHighlight:searchQuery"></label>
      </a>

      <label class="label-style" [innerHtml]="product.typenumber|searchHighlight:searchQuery"></label>

      <label class="label-style" [innerHtml]="product.name |searchHighlight:searchQuery"></label>
      @if (product?.sapEan) {
      <label class="label-style">GTIN : <span
          [innerHtml]="product?.sapEan | searchHighlight:searchQuery "></span></label>
      }
      <div class="compare_checkbox" [ngStyle]="{'visibility':product&&product.pdpLinkFlag ? 'visible':'hidden'}">
        <app-check-box-compare [product]="product"></app-check-box-compare>
      </div>

    </div>
    <div class="col-md-3 d-flex flex-column">
      <label class="label-style"
        [ngClass]="product.salesStatusCode=='CODE30' || product.salesStatusCode=='CODE40' ||product.salesStatusCode=='code30' || product.salesStatusCode=='code40'?'green-color':''">
        @if (product.salesStatusText?.indexOf('common.')<0) { <span class="product-type"
          [innerHtml]="product.salesStatusText|searchHighlight:searchQuery"></span>
          }
          @if (product.salesStatusText?.indexOf('common.')>-1) {
          <span class="product-type">@if (product.salesStatusText) {
            <span>{{product.salesStatusText|cxTranslate}}</span>
            }</span>
          }
      </label>

      <label class="product-type" [innerHtml]="product.marketType|searchHighlight:searchQuery"></label>

      @if (product.imppList[0].split(':')[0]) {
      <label class="d-flex"><span class="label-style">{{product.imppText|cxTranslate}} </span>
        @if (product?.imppList[0]?.split(':')[2] == 'false') {
        <span class="imp-value m-l" [innerHtml]="product.imppList[0].split(':')[0] |searchHighlight:searchQuery"></span>
        }
        @if (product?.imppList[0]?.split(':')[2] == 'true') {
        <a class="imp-value m-l" [href]="product?.imppList[0]?.split(':')[1]"
          [innerHtml]="product.imppList[0].split(':')[0] |searchHighlight:searchQuery"></a>
        }
      </label>
      }
      @if (product.crossReference[0]?.target) {
      <label class="label-bold-text mt-15"><span>{{'common.search_page_xref_number'|cxTranslate}}:&nbsp;&nbsp;</span>
        <span [innerHtml]="product.crossReference[0]?.target|searchHighlight:searchQuery"></span></label>
      }
      @if (product.crossReference[0]?.webName) {
      <label class="label-bold-text"><span>{{'common.search_page_xref_name'|cxTranslate}}:&nbsp;&nbsp;</span>
        <span class="camelCse"
          [innerHtml]="product.crossReference[0]?.webName|searchHighlight:searchQuery"></span></label>
      }

      @if (product.replacedByProductCode) {
      <label class="mt-20"><span class="label-style">{{product.replaceByText|cxTranslate}}</span> <a
          class="replaceByText m-l"
          [href]="product.replacedByPDPUrl">{{product.replacedByProductCode|searchHighlight:searchQuery}}</a></label>
      }
      @if (product.productReferences) {
      <label class="mt-20">{{'common.pdp_information_replacedby'|cxTranslate}}
        <span [innerHtml]="product.productReferences|searchHighlight:searchQuery"></span></label>
      }

    </div>

    <div class="col-md-3 d-flex flex-column priceBarDiv">
      @if (product.customerPriceText) {
      <label class="label-style d-flex justify-content-between ">{{product.customerPriceText|cxTranslate}}
        @if (!product.listPrice?.formattedValue) {
        <span class="font-bold">@if (product.customerPriceText) {
          <span>{{'common.basket_page_poa'|cxTranslate}}</span>
          }</span>
        }
        @if (product.listPrice?.formattedValue) {
        <span class="font-bold">{{product.listPrice?.formattedValue}}&nbsp;{{product.listPrice?.currencyIso}}</span>
        }
      </label>
      }
      @if (product.listPriceText) {
      <label class="label-style d-flex justify-content-between">{{product.listPriceText|cxTranslate}}
        @if (!product.listPrice?.formattedValue) {
        <span class="font-bold">@if (product.priceOnRequestText) {
          <span>{{product.priceOnRequestText|cxTranslate}}</span>
          }</span>
        }
        @if (product.listPrice?.formattedValue) {
        <span class="font-bold">{{product.listPrice?.formattedValue}}&nbsp;{{product.listPrice?.currencyIso}}</span>
        }
      </label>
      }
      @if (product.netPriceText) {
      <label class="label-style d-flex justify-content-between">{{product.netPriceText|cxTranslate}}
        @if (!product.netPrice?.formattedValue) {
        <span class="font-bold">@if (product.priceOnRequestText) {
          <span>{{product.priceOnRequestText|cxTranslate}}</span>
          }</span>
        }
        @if (product.netPrice?.formattedValue) {
        <span class="font-bold">{{product.netPrice?.formattedValue}}&nbsp;{{product.netPrice?.currencyIso}}</span>
        }
      </label>
      }
      @if (product.coreDepositeText) {
      <label class="label-style d-flex justify-content-between">{{product.coreDepositeText|cxTranslate}}
        @if (!product.corePrice?.formattedValue) {
        <span class="font-bold">@if (product.priceOnRequestText) {
          <span>{{product.priceOnRequestText|cxTranslate}}</span>
          }</span>
        }
        @if (product.corePrice?.formattedValue) {
        <span class="font-bold">{{product.corePrice?.formattedValue}}&nbsp;{{product.corePrice?.currencyIso}}</span>
        }
      </label>
      }
    </div>


    <div class="col-md-3 no-padding product-list-button-block">
      @if (isLoggedIn && product.isCheckAvailibility) {
      <button class='fs-16 btn btn-secondary btn-block check-avl check-avl-btn check-available'
        (click)="checkAvailability(product.code)">{{'common.check_availability_btn_text'|cxTranslate}}</button>
      }
      <app-kb-add-to-cart [showQuantity]="false" [purchasable]="product.isAddToCart" [productCode]="product?.code"
        class="kb-product-addToCart"></app-kb-add-to-cart>
      @if (isLoggedIn && product.isQoute) {
      <button class='btn btn-primary btn-block check-avl'>{{'common.quote_create'|cxTranslate}}</button>
      }
      @if (product.isContactUs && isLoggedIn && !product.isQoute) {
      <a class='btn btn-primary btn-block check-avl' [href]="product?.contactUsUrl"
        target="_blank">{{'common.pdp_page_contact_us'|cxTranslate}}</a>
      }
      @if (product.isEnqury && isLoggedIn) {
      <button class='btn btn-primary btn-block check-avl enquiry-btn'>{{
        'common.pdp_page_contact_enquiry' | cxTranslate }}</button>
      }
    </div>

  </div>
</div>